import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useState } from "react";

interface Props {
  // Each string in options is a button name, in a set order
  options: string[];
  // Each function in onClicks is a function, in the same order as options,
  //  that will run when each option is clicked
  onClicks: Function[];
  startingOption: string;
}

const ToggleSwitch = ({ options, onClicks, startingOption }: Props) => {
  const [activeOption, setActiveOption] = useState<string>(startingOption);
  return (
    <ToggleButtonGroup value={activeOption}>
      {options.map((option, index) => (
        <ToggleButton
          key={option}
          onClick={() => {
            onClicks[index]();
            setActiveOption(option);
          }}
          value={option}
          aria-label={option}
        >
          {option}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleSwitch;
